export const CONFLICTED = 'CONFLICTED'
export const ERROR = 'ERROR'
export const SHARED = 'SHARED'
export const SHARING = 'SHARING'
export const NOT_SHARING = 'NOT_SHARING'
